module.exports = __webpack_public_path__ + "src/assets/img/header_wissen_10_de.7834ba7f.png";